export const APP_LINK_GOOGLE_PLAY =
  "https://play.google.com/store/apps/details?id=fi.spicy.cryptonaire";
export const APP_LINK_APPLE_STORE =
  "https://apps.apple.com/gb/app/cryptonaire/id6444831636?uo=2";
